import React from 'react';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { b2cPolicies, loginRequest } from '../authConfig';
import { compareIssuingPolicy } from '../utils/claimUtils';
import './DataDisplay.css';

function DataDisplay() {
    const { instance, inProgress, accounts } = useMsal();
    const signInAccount = accounts.find((account) =>
        compareIssuingPolicy(account.idTokenClaims, b2cPolicies.names.signUpSignIn)
    );
    const activeAccount = instance.getActiveAccount() || signInAccount || accounts[0] || null;
    const activeClaims = activeAccount?.idTokenClaims;

    const currentUser = activeClaims ? {
        firstName: activeClaims.given_name || "N/A",
        lastName: activeClaims.family_name || "N/A",
        email: activeClaims.emails?.[0] || "N/A",
        city: activeClaims.city || "N/A",
        country: activeClaims.country || "USA",
        displayName: activeClaims.name || "N/A",
        jobTitle: activeClaims.jobTitle || "N/A",
        postalCode: activeClaims.postalCode || "N/A",
        state: activeClaims.state || "N/A",
        streetAddress: activeClaims.streetAddress || "N/A"
    } : null;

    const launchPolicy = (authority) => {
        if (!currentUser || inProgress !== InteractionStatus.None) {
            return;
        }

        sessionStorage.setItem('profileData', JSON.stringify(currentUser));
        instance.loginRedirect({
            ...loginRequest,
            authority,
        });
    };

    const handleEditProfile = () => {
        launchPolicy(b2cPolicies.authorities.editProfile.authority);
    };

    const handleChangePassword = () => {
        launchPolicy(b2cPolicies.authorities.changePassword.authority);
    };

    if (!currentUser) {
        return (
            <div className="profile-shell">
                <div className="profile-card">
                    <p className="profile-empty-state">No profile data available.</p>
                </div>
            </div>
        );
    }

    const profileFields = [
        { label: 'First Name', value: currentUser.firstName },
        { label: 'Last Name', value: currentUser.lastName },
        { label: 'Email Address', value: currentUser.email },
        { label: 'Display Name', value: currentUser.displayName },
        { label: 'Job Title', value: currentUser.jobTitle },
        { label: 'Street Address', value: currentUser.streetAddress },
        { label: 'City', value: currentUser.city },
        { label: 'State / Province', value: currentUser.state },
        { label: 'Postal Code', value: currentUser.postalCode },
        { label: 'Country / Region', value: currentUser.country }
    ];

    return (
        <div className="profile-shell">
            <div className="profile-card">
                <div className="profile-card-header">
                    <span className="profile-badge">Account</span>
                    <h1>Your profile</h1>
                    <p>Review your account information and manage your sign-in details.</p>
                </div>

                <div className="profile-grid">
                    {profileFields.map((field) => (
                        <div className="profile-field" key={field.label}>
                            <span className="profile-label">{field.label}</span>
                            <span className="profile-value">{field.value}</span>
                        </div>
                    ))}
                </div>

                <div className="profile-actions">
                    <button className="profile-action-button primary" onClick={handleEditProfile}>
                        Edit Profile
                    </button>
                    <button className="profile-action-button secondary" onClick={handleChangePassword}>
                        Change Password
                    </button>
                </div>

                <p className="profile-footnote">
                    Profile updates may not appear immediately. Changes usually show shortly after you complete the update.
                </p>
            </div>
        </div>
    );
}

export default DataDisplay;
